import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart6Config, GeneralProceduresCricMainConfig } from "../GeneralProceduresCricMain";

export default class GeneralProceduresCricPart6 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart6Config {
		return this.scenarioConfig.part6Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.step1ShowInsertionAngleUI();
	}

	public step1ShowInsertionAngleUI() {
		const context = this;
		context.scenario.uiWrapper.displayInsertionAngleUI({
			OnNextClicked: (selectedAngleIndx: number, selectedDepth: number) => {
				var isCorrect = selectedAngleIndx === 0 && (selectedDepth>= 5 && selectedDepth <= 7);

				if(!isCorrect) {
					context.scenario.cricInsertBougiePoints = 100;
					context.scenario.displayMessage("This is an incorrect selection. Please try again", () => {
						context.step1ShowInsertionAngleUI();
					})
					return;
				}
				if(context.config.onInsertionAngleNextClicked) {
					context.config.onInsertionAngleNextClicked(selectedAngleIndx, selectedDepth);
				}
				context.step2ShowInsertionWait();
			}
		})
	}

	public step2ShowInsertionWait() {
		const context = this;
		context.scenario.addScore(context.scenario.cricInsertBougiePoints);
		var onDoneWithPopup = context._scenario.doSomething('Inserting Bougie...');
		context.playVideoChapter(context.config.bougieVideoChapter(), () => {
			
		});

		setTimeout(() => {
			onDoneWithPopup();
			context.onDone();
		}, constants.doSomethingTimeout);
	}
}